import template from './product-look-up.html';

(function ($, ko) {
    function ProductLookUp(params) {
        const self = this;
        self.storeProducts = ko.observableArray();
        self.productIds = ko.observableArray();
        self.productKeyword = ko.observable('')
        self.productSearchName = ko.observable('');
        self.productLookUpService = new $.cdh.http.smartAccount.ProductLookUpService;
        self.disableSearchButton = ko.observable(false);
        self.disableScanner = ko.observable(false);
        self.disableScannerButton = ko.observable(false);
        self.formatsToSupport = [Html5QrcodeSupportedFormats.UPC_A, Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8, Html5QrcodeSupportedFormats.PDF_417,
        Html5QrcodeSupportedFormats.RSS_14, Html5QrcodeSupportedFormats.RSS_EXPANDED,
        Html5QrcodeSupportedFormats.UPC_A, Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION, Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.AZTEC, Html5QrcodeSupportedFormats.CODABAR,
        Html5QrcodeSupportedFormats.CODE_39, Html5QrcodeSupportedFormats.CODE_93,
        Html5QrcodeSupportedFormats.CODE_128, Html5QrcodeSupportedFormats.DATA_MATRIX,
        Html5QrcodeSupportedFormats.MAXICODE, Html5QrcodeSupportedFormats.ITF];
        self.getMobileOperatingSystem = function () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/iPhone|iPad|iPod/i.test(userAgent)) {
                return "iOS";
            }
            if (/Android/i.test(userAgent)) {
                return "Android";
            }
            return "Other";
        }

        const config = {
            fps: 10,
            formatsToSupport: self.formatsToSupport,
            focusMode: "continuous",
            qrbox: {
                width: 250,
                height: 250
            },
            advanced: [{ zoom: 2.0 }],
            disableFlip: false,
            videoConstraints: {
                aspectRatio: 1.0,
                facingMode: "environment",
                width: { ideal: 1920 },
                height: { ideal: 1080 },
                focusMode: "continuous",
                advanced: [{ zoom: self.getMobileOperatingSystem() == "Android" ? 1.5 : 2.0 }]
            }
        };

        self.html5QrCode = new Html5Qrcode("reader", {
            fps: 10,
            qrbox: { width: self.getMobileOperatingSystem() == "iOS" ? 250 : 300, height: self.getMobileOperatingSystem() == "iOS" ? 110 : 130 },
            showTorchButtonIfSupported: true,
            rememberLastUsedCamera: true,
            useBarCodeDetectorIfSupported: true,
            formatsToSupport: self.formatsToSupport,
            experimentalFeatures: {
                useBarCodeDetectorIfSupported: true
            },
        });
        document.getElementById("reader").style.display = "none";
        document.getElementById("product-search-results").style.display = "block";
        self.showBarcodeScanError = ko.observable(false);
        self.isScanning = false;
        self.showPermissionDeniedError = ko.observable(false);
        self.starLoaderForScanner = ko.observable(false);

        // code to check if the application is accessed via mobile browser
        self.isMobileBrowser = function () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // Check for iOS or Android
            return /iPhone|iPad|iPod|Android/i.test(userAgent) && window.innerHeight < window.innerWidth;
        }
        self.disableScanner(self.isMobileBrowser());
        self.searchProducts = function (data, event) {
            document.getElementById("product-search-results").style.display = "block";
            self.disableScannerButton(false);
            self.showBarcodeScanError(false);
            self.showPermissionDeniedError(false);
            if (self.isMobileBrowser()) {
                self.closeScanner();
                self.isScanning = false;
                const readerDiv = document.getElementById("reader");
                readerDiv.style.display = "none";
                const searchResultsDiv = document.querySelector(".product-search-results");
                const searchBarDiv = document.querySelector(".product-search-bar");
                searchBarDiv.parentNode.insertBefore(searchResultsDiv, searchBarDiv.nextSibling);
            }
            self.productIds([]);
            self.productKeyword('');

            var searchProduct = self.productSearchName().trim();
            var isOnlyDigits = /^[\d\s,]+$/.test(searchProduct);
            var isOnlyAlphabets = /^[a-zA-Z\s,]+$/.test(searchProduct);

            if (isOnlyDigits) {
                if (self.productSearchName().includes(',')) {
                    self.productIds(self.productSearchName().split(',').map(item => item.trim()).filter(value => value.length));
                } else {
                    self.productIds.push(searchProduct)
                }
            }
            else if (isOnlyAlphabets) {
                if (self.productSearchName().includes(',')) {
                    const firstProductName = self.productSearchName().split(',')[0].trim();
                    self.productKeyword(firstProductName);
                } else {
                    self.productKeyword(searchProduct)
                }
            }

            const payload = {
                "ProductIds": self.productIds(),
                "productsKeyword": self.productKeyword()
            }

            self.productLookUpService.ProductSearch(payload).then(function (result) {
                self.storeProducts(result.xhr.responseJSON.Products);
            }).catch(function (data) {
                self.storeProducts([]);
            });
        };

        // barcode scanner functionality
        self.openScanner = function (data, event) {
            if (!self.isScanning) {
                self.starLoaderForScanner(true);
                self.showBarcodeScanError(false);
                self.showPermissionDeniedError(false);
                document.getElementById("reader").style.display = "flex";
                document.getElementById("reader").style.opacity = "0";
                document.getElementById("product-search-results").style.display = "none";

                const onScanSuccess = (decodedText, decodedResult) => {
                    self.showBarcodeScanError(false);
                    document.getElementById("reader").style.display = "none";
                    self.disableScannerButton(false);
                    self.productSearchName(decodedText);
                    self.disableSearchButton(true);
                    self.searchProducts();
                    self.html5QrCode.stop().then(() => {
                        self.isScanning = false;
                    });
                };
                if (!self.isScanning) {
                    self.html5QrCode.start({ facingMode: "environment" }, config, onScanSuccess,
                        (errorMessage) => {
                            self.showBarcodeScanError(false);
                            const error = errorMessage.includes("No MultiFormat Readers were able to detect the code") ||
                                errorMessage.includes("No barcode or QR code detected") ||
                                errorMessage.includes("scanner is not running or paused.") ||
                                errorMessage.includes("Cannot transition to a new state, already under transition");

                            if (!error) {
                                self.starLoaderForScanner(false);
                                self.showBarcodeScanError(true);
                            }
                        }).then(() => {
                            self.isScanning = true;
                            const constraints = {
                                focusMode: "continuous",
                                advanced: [{ zoom: 2.0 }]
                            };

                        self.html5QrCode.applyVideoConstraints(constraints);
                        })
                        .catch((err) => {
                            if ((err.indexOf('Permission denied') > -1) || (err.indexOf('user denied permission') > -1)) {
                                self.showBarcodeScanError(false);
                                self.starLoaderForScanner(false);
                                self.showPermissionDeniedError(true);
                            }
                        });

                }

                // Use MutationObserver to apply styles once the video element is added
                const observer = new MutationObserver(() => {
                    const interval = setInterval(() => {
                        const videoElement = $("#reader video")[0];
                        const qrShadeRegion = document.querySelector("#reader #qr-shaded-region");
                        const closeButton = document.querySelector("#closeButton");
                        if (qrShadeRegion && videoElement) {
                            clearInterval(interval);
                            if (self.getMobileOperatingSystem() == "iOS") {
                                videoElement.classList.add("applyVideoStylesIos");
                                closeButton.classList.add("applyCloseBtnStylesIos");
                            } else {
                                videoElement.classList.add("applyVideoStylesAndroid");
                                qrShadeRegion.classList.add("applyQRStylesAndroid");
                                closeButton.classList.add("applyCloseBtnStylesAndroid");
                            }
                            self.starLoaderForScanner(false);
                            document.getElementById("reader").style.opacity = "100";
                            self.disableScannerButton(true);
                        }
                    }, 100);
                    observer.disconnect();
                });
                observer.observe(document.getElementById("reader"), { childList: true, subtree: true });
            }
        }

        self.closeScanner = function () {
            self.showBarcodeScanError(false);
            self.showPermissionDeniedError(false);
            document.getElementById("reader").style.display = "none";
            document.getElementById("product-search-results").style.display = "block";
            self.disableScannerButton(false);
            // Stop the scanner
            if (self.isScanning) {
                self.html5QrCode.stop().then(() => {
                    self.isScanning = false;
                }).catch(err => { });
            }
        }

        // Function to trigger on Enter key press
        self.searchOnEnter = function (data, event) {
            if (event.key === 'Enter' && self.disableSearchButton()) {
                self.searchProducts();
                return false;
            }
            return true;
        };


        document.getElementById('ProductId').addEventListener('keyup', function (newData) {
            if (newData.target.value.length > 0) {
                self.productSearchName(newData.target.value);
                self.disableSearchButton(true)
            } else {
                self.disableSearchButton(false)
            }
        })

        function handleOrientation() {
            const orientationWarning = document.getElementById('orientation-warning');
            const isPortrait = window.innerHeight > window.innerWidth;

            self.disableScanner(isPortrait);

            if (orientationWarning) {
                orientationWarning.style.display = (self.isMobileBrowser() && !isPortrait) ? 'block' : 'none';
            }

            if (!isPortrait && self.isScanning) {
                self.closeScanner();
                self.isScanning = false;
            }
        }

        // Call the function immediately to handle the current orientation
        handleOrientation();

        // Call the function on window resize
        window.addEventListener('resize', handleOrientation);
    }

    self.onlyAlpaNumericAndComma = function (data, event) {
        const charCode = event.charCode;
        const char = String.fromCharCode(charCode);
        const isValid = /^[A-Za-z0-9, ]$/.test(char);
        return isValid;
    };

    ko.components.register('product-look-up', {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo) {
                return new ProductLookUp(params, componentInfo);
            }
        }
    });

    self.clickFindStores = function () {
        window.location.href = $.cdh.routes.predefined.ila.merchants
    };

})(jQuery, ko);